import {Component, Input, OnInit} from "@angular/core";
import {FormControl, FormGroup} from "@angular/forms";
import {MatTabChangeEvent} from "@angular/material/tabs";
import {ICompanionForm} from "../../../../../../shared/interfaces/forms/exercises/ICompanionForm";
import {ECompanionAgilityType} from "../../../../../../shared/enums/ECompanionAgilityType";
import {ECompanionNumberType} from "../../../../../../shared/enums/ECompanionNumberType";
import {ValidationHelperService} from "../../../../../../core/helpers/validation-helper.service";
import {
  COMPANION_DELAY_OPTIONS,
  COMPANION_PROMPT_OPTIONS,
} from "../../companion-timer-options";
import {COMPANION_COLOR_OPTIONS} from "../../companion-color-options";

@Component({
  selector: "app-companion-agility-form",
  templateUrl: "./companion-agility-form.component.html",
  styleUrls: ["./companion-agility-form.component.scss"],
})
export class CompanionAgilityFormComponent implements OnInit {
  @Input() _formGroup: FormGroup<ICompanionForm>;
  readonly delayOptions = COMPANION_DELAY_OPTIONS;
  readonly promptOptions = COMPANION_PROMPT_OPTIONS;
  readonly colorOptions = COMPANION_COLOR_OPTIONS;

  ngOnInit(): void {
    this.normalizeCompanionType();
  }

  get agilityType(): FormControl<ECompanionAgilityType> {
    return this._formGroup.controls.agilityType;
  }

  get numberType(): FormControl<ECompanionNumberType> {
    return this._formGroup.controls.numberType;
  }

  get companionTypeTabIndex(): number {
    return this.agilityType.value === ECompanionAgilityType.Number ? 1 : 0;
  }

  get react(): boolean[] {
    return this._formGroup.controls.reactTo.value;
  }

  get dontReact(): boolean[] {
    return this._formGroup.controls.dontReactTo.value;
  }

  get showPromptControl(): boolean {
    return (
      this.agilityType.value !== ECompanionAgilityType.Number ||
      this.numberType.value === ECompanionNumberType.SingleValue
    );
  }

  onAgilityTabChange(event: MatTabChangeEvent): void {
    const visualTypes = [
      ECompanionAgilityType.Color,
      ECompanionAgilityType.Number,
    ];
    const selected = visualTypes[event.index];
    if (selected !== undefined) {
      this.agilityType.setValue(selected);
      this._formGroup.updateValueAndValidity();
    }
  }

  onNumberTabChange(event: MatTabChangeEvent): void {
    this.numberType.setValue(event.index as ECompanionNumberType);
    this._formGroup.updateValueAndValidity();
  }

  setReact(color: number, dontReact: boolean): void {
    const selected = dontReact
      ? this._formGroup.controls.dontReactTo
      : this._formGroup.controls.reactTo;
    const opposite = dontReact
      ? this._formGroup.controls.reactTo
      : this._formGroup.controls.dontReactTo;
    selected.controls[color].setValue(!selected.controls[color].value);
    if (selected.controls[color].value && opposite.controls[color].value) {
      opposite.controls[color].setValue(false);
    }
    this._formGroup.updateValueAndValidity();
  }

  private normalizeCompanionType(): void {
    if (
      this.agilityType.value !== ECompanionAgilityType.Color &&
      this.agilityType.value !== ECompanionAgilityType.Number
    ) {
      this.agilityType.setValue(ECompanionAgilityType.Color);
      this._formGroup.updateValueAndValidity();
    }
  }

  protected readonly ECompanionAgilityType = ECompanionAgilityType;
  protected readonly ECompanionNumberType = ECompanionNumberType;
  protected readonly ValidationHelperService = ValidationHelperService;
}
